import { call, put } from "redux-saga/effects";
import { updateConferenceParticipantListAction } from "../updateConferenceParticipantList/action";
import cirrusClient from "../../../services/api/cirrus-client";


export function* removeConferenceParticipantSaga(action) {
    try {
        const { conferenceUri, participantId } = action.payload;
        const apiUrl = '?object=participant&action=disc'

        const params = {
            conference_match: conferenceUri,
            participant_match: participantId,
        };
        yield call(cirrusClient.post, apiUrl, params);
        
        // After successful API call, update the participant list
        yield put(updateConferenceParticipantListAction({ conferenceUri }));


    } catch (error) {
        console.error('Error removing participant in the conference', error);
    }


}